import { render, staticRenderFns } from "./AdBlockFallback.vue?vue&type=template&id=29b365f1"
import script from "./AdBlockFallback.vue?vue&type=script&lang=ts"
export * from "./AdBlockFallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports